// client/src/pages/Messages.jsx
import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import request from '../utils/request';
import { AIMATCH_TAB_ACTIVATE } from '../utils/tabActivate';

function getBirthYear(item) {
  if (item.birthday) return item.birthday.slice(2, 4) + '年';
  if (item.age) return String(new Date().getFullYear() - item.age).slice(2) + '年';
  return null;
}

function HistoryItem({ item, navigate, onDelete }) {
  const [showMessages, setShowMessages] = useState(false);
  const [copied, setCopied] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const isSent = item.direction === 'sent';
  const briefInfo = [getBirthYear(item), item.height ? `${item.height}cm` : null, item.job].filter(Boolean).join(' ');

  const copyWechat = async () => {
    if (!item.wechat) return;
    try {
      await navigator.clipboard.writeText(item.wechat);
    } catch (e) {
      const input = document.createElement('input');
      input.value = item.wechat;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleDelete = async () => {
    if (!window.confirm('确定删除这条牵线记录吗？')) return;
    setDeleting(true);
    try {
      await onDelete(item.id);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div className="card" style={{ position: 'relative' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          cursor: item.other_user_id ? 'pointer' : undefined,
        }}
        onClick={() => item.other_user_id && navigate(`/profile/${item.other_user_id}`)}
      >
        <img
          src={item.avatar || 'https://via.placeholder.com/48'}
          alt={item.nickname}
          style={{ width: 48, height: 48, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
        />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <h3 style={{ margin: 0, fontSize: 16 }}>{item.nickname}</h3>
            <span style={{ fontSize: 11, color: '#999' }}>{isSent ? '我发起' : '我收到'}</span>
            <span style={{
              padding: '2px 8px', borderRadius: 10, fontSize: 11,
              backgroundColor: item.status === 'agreed' ? '#e8f5e9' : '#ffebee',
              color: item.status === 'agreed' ? '#4caf50' : '#f44336'
            }}>
              {item.status === 'agreed' ? '已同意' : '已拒绝'}
            </span>
          </div>
          <p style={{ color: '#888', fontSize: 13, marginTop: 4 }}>
            {briefInfo || '资料未完善'}
          </p>
        </div>
        <button
          onClick={(e) => { e.stopPropagation(); handleDelete(); }}
          disabled={deleting}
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: '#ccc', fontSize: 16, padding: '4px'
          }}
          title="删除记录"
        >
          ✕
        </button>
      </div>

      {/* 成功牵线 - 微信号 */}
      {item.status === 'agreed' && (
        <div
          style={{
            marginTop: 10, padding: '10px 12px', background: '#f0faf0',
            borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'space-between'
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div>
            <span style={{ fontSize: 12, color: '#999' }}>微信号：</span>
            <span style={{ fontSize: 12 }}>{item.wechat || '未填写'}</span>
          </div>
          <button
            className="btn btn-primary"
            style={{ padding: '4px 12px', fontSize: 12 }}
            onClick={copyWechat}
            disabled={!item.wechat}
          >
            {copied ? '已复制 ✓' : '复制'}
          </button>
        </div>
      )}

      {/* 留言 - 被拒绝时 */}
      {item.status === 'rejected' && (
        <div style={{ marginTop: 8 }} onClick={(e) => e.stopPropagation()}>
          <button
            className="btn btn-secondary"
            style={{ width: '100%', fontSize: 13, padding: '8px 0' }}
            onClick={() => setShowMessages(!showMessages)}
          >
            {showMessages ? '收起留言' : '查看留言'}
          </button>
          {showMessages && (
            <div style={{ marginTop: 8 }}>
              {/* 我发起：request_message=我的留言，reject_message=对方的留言；我收到：request_message=对方的留言，reject_message=我的留言 */}
              {isSent ? (
                <>
                  {item.request_message && (
                    <div style={{
                      padding: 10, background: '#fff8e1', borderRadius: 8,
                      color: '#666', fontSize: 13, marginBottom: 8
                    }}>
                      <span style={{ color: '#ff9800', fontWeight: 500 }}>💌 我的留言：</span>
                      {item.request_message}
                    </div>
                  )}
                  {item.reject_message ? (
                    <div style={{
                      padding: 10, background: '#fce4ec', borderRadius: 8,
                      color: '#666', fontSize: 13
                    }}>
                      <span style={{ color: '#f44336', fontWeight: 500 }}>👋 对方的留言：</span>
                      {item.reject_message}
                    </div>
                  ) : (
                    <div style={{ padding: 10, color: '#999', fontSize: 13 }}>
                      👋 对方婉拒时未留言
                    </div>
                  )}
                </>
              ) : (
                <>
                  {item.request_message && (
                    <div style={{
                      padding: 10, background: '#fce4ec', borderRadius: 8,
                      color: '#666', fontSize: 13, marginBottom: 8
                    }}>
                      <span style={{ color: '#f44336', fontWeight: 500 }}>💌 对方的留言：</span>
                      {item.request_message}
                    </div>
                  )}
                  {item.reject_message ? (
                    <div style={{
                      padding: 10, background: '#fff8e1', borderRadius: 8,
                      color: '#666', fontSize: 13
                    }}>
                      <span style={{ color: '#ff9800', fontWeight: 500 }}>👋 我的留言：</span>
                      {item.reject_message}
                    </div>
                  ) : (
                    <div style={{ padding: 10, color: '#999', fontSize: 13 }}>
                      👋 我婉拒时未留言
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      )}

      {/* 成功牵线 - 留言（如有） */}
      {item.status === 'agreed' && item.request_message && (
        <div
          style={{
          marginTop: 8, padding: 10, background: '#fff8e1',
          borderRadius: 8, color: '#666', fontSize: 13
        }}
          onClick={(e) => e.stopPropagation()}
        >
          <span style={{ color: '#ff9800', fontWeight: 500 }}>💌 {isSent ? '我的留言' : '对方的留言'}：</span>
          {item.request_message}
        </div>
      )}
    </div>
  );
}

function Messages({ defaultTab = 'pending' }) {
  const [pending, setPending] = useState([]);
  const [sent, setSent] = useState([]);
  const [history, setHistory] = useState([]);
  const [activeTab, setActiveTab] = useState(defaultTab);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchData = useCallback(async (opts = {}) => {
    const silent = opts.silent === true;
    if (!silent) setLoading(true);
    try {
      const [pendingRes, sentRes, historyRes] = await Promise.all([
        request({ url: '/api/matches/pending', method: 'GET' }),
        request({ url: '/api/matches/sent', method: 'GET' }),
        request({ url: '/api/match-history', method: 'GET' })
      ]);
      setPending(Array.isArray(pendingRes.data) ? pendingRes.data : []);
      setSent(Array.isArray(sentRes.data) ? sentRes.data : []);
      setHistory(Array.isArray(historyRes.data) ? historyRes.data : []);
    } catch (err) {
      console.error('获取消息失败:', err);
    } finally {
      if (!silent) setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData({ silent: false });
  }, [fetchData]);

  useEffect(() => {
    const onTab = (e) => {
      if (e.detail?.path === '/messages') fetchData({ silent: true });
    };
    window.addEventListener(AIMATCH_TAB_ACTIVATE, onTab);
    return () => window.removeEventListener(AIMATCH_TAB_ACTIVATE, onTab);
  }, [fetchData]);

  const handleDeleteHistory = async (id) => {
    try {
      await request({ url: `/api/match-history/${id}`, method: 'DELETE' });
      setHistory(prev => prev.filter(item => item.id !== id));
    } catch (err) {
      alert('删除失败，请稍后重试');
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="loading">加载中...</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <h2 style={{ marginBottom: 20 }}>💬 消息中心</h2>

      {/* 标签切换 */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        <button
          className={`btn ${activeTab === 'pending' ? 'btn-primary' : 'btn-secondary'}`}
          style={{ flex: 1, minWidth: 80 }}
          onClick={() => {
            setActiveTab('pending');
            fetchData({ silent: true });
          }}
        >
          待处理 {pending.length > 0 && `(${pending.length})`}
        </button>
        <button
          className={`btn ${activeTab === 'sent' ? 'btn-primary' : 'btn-secondary'}`}
          style={{ flex: 1, minWidth: 80 }}
          onClick={() => {
            setActiveTab('sent');
            fetchData({ silent: true });
          }}
        >
          我发起的 {sent.length > 0 && `(${sent.length})`}
        </button>
        <button
          className={`btn ${activeTab === 'history' ? 'btn-primary' : 'btn-secondary'}`}
          style={{ flex: 1, minWidth: 80 }}
          onClick={() => {
            setActiveTab('history');
            fetchData({ silent: true });
          }}
        >
          历史记录
        </button>
      </div>

      {/* 待处理列表 */}
      {activeTab === 'pending' && (
        <div>
          {pending.length === 0 ? (
            <div className="card" style={{ textAlign: 'center', padding: 40 }}>
              <p>暂无待处理的牵线请求</p>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {pending.map(item => {
              const birthYear = item.birthday ? item.birthday.slice(2, 4) + '年' : (item.age ? String(new Date().getFullYear() - item.age).slice(2) + '年' : null);
              const briefInfo = [birthYear, item.height ? `${item.height}cm` : null, item.job].filter(Boolean).join(' ');
              return (
                <div
                  key={item.id}
                  className="card"
                  onClick={() => navigate(`/match/${item.id}`)}
                  style={{ display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer' }}
                >
                  <img
                    src={item.avatar || 'https://via.placeholder.com/48'}
                    alt={item.nickname}
                    style={{ width: 48, height: 48, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                  />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <h3 style={{ margin: 0, fontSize: 16 }}>{item.nickname}</h3>
                    <p style={{ color: '#888', fontSize: 13, marginTop: 4 }}>
                      {briefInfo || '资料未完善'}
                    </p>
                  </div>
                  <span style={{ color: '#999', fontSize: 14 }}>→</span>
                </div>
              );
            })}
            </div>
          )}
        </div>
      )}

      {/* 我发起的（待对方回复） */}
      {activeTab === 'sent' && (
        <div>
          {sent.length === 0 ? (
            <div className="card" style={{ textAlign: 'center', padding: 40 }}>
              <p>暂无发起的牵线请求</p>
              <p style={{ color: '#999', fontSize: 13, marginTop: 8 }}>在发现页向心动的人发起牵线后，会在这里显示</p>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {sent.map(item => {
                const birthYear = item.birthday ? item.birthday.slice(2, 4) + '年' : (item.age ? String(new Date().getFullYear() - item.age).slice(2) + '年' : null);
                const briefInfo = [birthYear, item.height ? `${item.height}cm` : null, item.job].filter(Boolean).join(' ');
                return (
                  <div
                    key={item.id}
                    className="card"
                    onClick={() => item.other_user_id && navigate(`/profile/${item.other_user_id}`)}
                    style={{ display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer' }}
                  >
                    <img
                      src={item.avatar || 'https://via.placeholder.com/48'}
                      alt={item.nickname}
                      style={{ width: 48, height: 48, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                    />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <h3 style={{ margin: 0, fontSize: 16 }}>{item.nickname}</h3>
                      <p style={{ color: '#888', fontSize: 13, marginTop: 4 }}>
                        {briefInfo || '资料未完善'}
                      </p>
                      {item.request_message && (
                        <p style={{ color: '#999', fontSize: 12, marginTop: 4 }}>留言：{item.request_message}</p>
                      )}
                    </div>
                    <span style={{ color: '#ff9800', fontSize: 12 }}>等待回复</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* 历史记录 */}
      {activeTab === 'history' && (
        <div>
          {history.length === 0 ? (
            <div className="card" style={{ textAlign: 'center', padding: 40 }}>
              <p>暂无牵线历史</p>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {history.map(item => (
              <HistoryItem key={item.id} item={item} navigate={navigate} onDelete={handleDeleteHistory} />
            ))}
            </div>
          )}
        </div>
      )}
    </Layout>
  );
}

export default Messages;
